import { render } from "./BreadcrumbSection.vue?vue&type=template&id=feb4e27a"
import script from "./BreadcrumbSection.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__